/**
 * @title scheduledDeliverable.js: Sub-module
 * @description Associated with DeliverableAvailabilityForm.jsp and ScheduleDeliverableModal
 *
 */
define(['product_helper'], function(phelper) {
  var ScheduledDeliverable = {
    init: function() {
      if ($('#DeliveryAvailabilityForm').length > 0 || $('.parts-and-services').length > 0) {
        //this.registerOnClickGoButton();
        $("#reset-delivery-form").unbind('click').click(function() {
          COSTCO.ScheduledDeliverable.resetDeliverableForm();
        });
        $("#reset-delivery-form-error").unbind('click').click(function() {
        	COSTCO.ScheduledDeliverable.resetDeliverableForm();
          });
        COSTCO.ScheduledDeliverable.maskZipInput();
        COSTCO.ScheduledDeliverable.maskPhone();
        COSTCO.ScheduledDeliverable.validationRules.phone();
        COSTCO.ScheduledDeliverable.popovers();
        $('body').bind("costco.address.added", function(event, address) {
        	COSTCO.ScheduledDeliverable.maskPhone();
        	COSTCO.ScheduledDeliverable.validationRules.phone();
        });
    	
        $(window).on('beforeunload', function(){
        	sessionStorage.removeItem('DeliveryReservationCalendarData');
     	});
        
      }
    },
    popovers: function() {
        $('.co-help').popover();
      },
    validate: {
      deliveryAvailabilityForm: function(form) {
    	  COSTCO.ScheduledDeliverable.validationRules.zipcode();
        return $(form).validate({
          rules: {
            deliveryZipCode: {
              required: true,
              countryspecificpostalcodePassCountrySelectorModal: true
            }
          },
          messages: {
            deliveryZipCode: messages.SCHD_ENTER_VALID_ZIP_CODE
          },
          invalidHandler: function(event, validator) {
        	validator.errorList[0].element.focus();
          },
          highlight: COSTCO.util.highlightWithErrorLabel,
          unhighlight: COSTCO.util.unhighlightWithErrorLabel
        }).form();
      },
      partsAndServicesPhone: function(element) {
        var form = element.form;
        var validator = $(form).validate();
        $('input[id^="contactPhone"]').each(function(i, input) {
          $(input).rules("add", {
            required: true,
            contactPhone: true,
            messages: {
              contactPhone: messages.ERR_INVALID_PHONE1
            }
          })
        });
        return validator.element("#" + element.id);
      },
      partsAndServicesDeliverableDates: function(element) {
        var form = element.form;
        var validator = $(form).validate();
        $('input[id^="deliveryDate"]').each(function(i, input) {
          $(input).rules("add", {
            required: true
          })
        });
        return validator.element("#" + element.id);
      }
    },
    validationRules: {
      phone: function() {
        $.validator.addMethod("contactPhone", function(value, element) {
          if (value.startsWith("0") || value.startsWith("1")) {
            return false;
          }
          return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
        }, messages.ERR_INVALID_PHONE1);
      },
      zipcode: function() {
        $.validator.addMethod("countryspecificpostalcodePassCountrySelectorModal", function(value, element) {
          return !COSTCO.ScheduledDeliverable.isUS() ? this.optional(element) || /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/.test($.trim(value)) : this.optional(element) || /^(\d{5}(-\d{4})?$)$/.test($.trim(value));
        }, messages.ERR_ENTER_ZIPCODE);
      }
    },
    isUS: function() {
      if (COSTCO.util.getLangId() != -1) {
        return false;
      }
      return true;
    },
    /**
     * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val() to get unformatted value
     */
    maskZipInput: function() {
      if (COSTCO.ScheduledDeliverable.isUS()) {
        $('#delivery-zip').unmask().mask('00000');
      } else {
        $('#delivery-zip').unmask().mask('S0S 0S0');
      }
    },
    maskPhone: function() {
      $('input[id^="contactPhone"]').each(function(i, input) {
        $(input).unmask().mask('000-000-0000');
      });
    },
    registerOnClickGoButton: function() {
      $("#submit-delivery-area").unbind('click').click(function() {
        disableZipInput();
        var vendorSku = $('#deliveryVendorSku').val();
        var zipcode = $('#delivery-zip').val();
        var zipcodeCookie = $.cookie('invCheckPostalCode');
        var productSku = $('#productPartnumberVal').val();
        var url = "AjaxDeliveryReservationCalendarCmd?storeId=10301&deliveryVendorSku=" + vendorSku + "&zipCode=" + zipcode + "&productSku=" + productSku;
        if(zipcode === zipcodeCookie){
        	COSTCO.ScheduledDeliverable.submitDeliverableAvailabilityAjax({
                sku: vendorSku,
                url: url,
                productSku : productSku,
                zipCode: zipcode
              });
        }else {
        
	        let serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
	        serviceToUpdateCookies(zipcode)
	        .then(() => {
	        	var state = $.cookie('invCheckStateCode');
	        	window.wioEventBus.publish('changeDeliveryLocation', zipcode);
	        })
	       .fail((data) => {
	         // bing failed
	    	 $('#zip-group').addClass('hide');
	         let errorContainer = $('#zip-group').find('label.error');
	         errorContainer.empty();
	         errorContainer.append(messages.ERR_ENTER_ZIPCODE);
	         errorContainer.show();
	       });
	      }
      })
    },
    setDeliverableInputsFromSelectedProduct: function() {
      var selectedProduct = COSTCO.Product.getSelectedBundleAndVariantItems();
      $('#deliveryVendorSku').val(selectedProduct[0].manufacturerPartNumber);
    },
    disableZipInput: function() {
      $('#zip-group').addClass("order-ajax ajax-busy");
    },
    enableZipInput: function() {
      $('#zip-group').removeClass("order-ajax ajax-busy");
    },
    disableQtyInput: function() {
      $('#select-options').addClass("order-ajax ajax-busy");
      $('#qty-input').addClass("order-ajax ajax-busy");
      $('#qty').addClass("order-ajax ajax-busy");
    },
    enableQtyInput: function() {
      $('#select-options').removeClass("order-ajax ajax-busy");
      $('#qty-input').removeClass("order-ajax ajax-busy");
      $('#qty').removeClass("order-ajax ajax-busy");
    },
    /**
     * Calls bing and updates zip/state/city cookies
     * @retrns jquery Deferred object
     */
    callBingOrGeocodeAndUpdateCookies: function(event) {

      let deferred = $.Deferred();
      var zipcode = $('#delivery-zip').val();
      let updateCookieValues = function(data) {
      if ($('#isGeocodeService').val() != "true") {
    	  let totalResponses = data.resourceSets[0].estimatedTotal;
      } else {
    	  let totalResponses = data.length;
      }
      let province = null;
      let country = null;
      let city = null;
        if (totalResponses != 0) {
        	if ($('#isGeocodeService').val() != "true") {
	            city = data.resourceSets[0].resources[0].address.locality;
	            try {
	                //Check out if country is Puerto Rico specific
	                country = data.resourceSets[0].resources[0].address.countryRegionIso2;
	                if (country != undefined && country === 'PR') {
	                  province = data.resourceSets[0].resources[0].address.countryRegionIso2;
	                  country = 'US';
	                } else {
	                  province = data.resourceSets[0].resources[0].address.adminDistrict;
	                }
	            } catch (e) {
	                province = "";
	            }
        	} else {
        		try {
        			city = data[0].city;
                    province = data[0].stateProvinceAbbreviation;
                    if (province == null) {
                      province = data[0].stateProvince;
                    }
                    country = data[0].country;
        		} catch (e) {
        			console.error('Error: '+ e.message);
        		}
        		
        	}
        	$.cookie("invCheckPostalCode", zipcode);
        	$.cookie("invCheckStateCode", province);
        	$.cookie("invCheckCity", city);
        	
        	window.location.reload();
        	deferred.resolve(data);
        } else {
        	errorMessage = messages.SHIP_RESTRICTION_INVALID_MESSAGE;
        	errorMessage = errorMessage.replace(/\{0\}/g, zipcode);
        	var productErrorDiv = $('.product-error');
        	$(".product-error").empty();
        	productErrorDiv.append( '<p class="alert-notification">' + errorMessage + '</p>');
        	deferred.reject();
        }
      }
      if ($('#isGeocodeService').val() != "true") {
    	  COSTCO.util.callBing(zipcode, updateCookieValues);  
      } else {
    	  COSTCO.util.callGeocodeAPI(zipcode, updateCookieValues);
      }
      

      return deferred.promise();
    },    
    validateEDDScheduledDelivery: function(event) {
    	event.preventDefault();
    	 if (COSTCO.ScheduledDeliverable.validate.deliveryAvailabilityForm(event.currentTarget.form || event.currentTarget)) {
    		 var zipcode = $('#delivery-zip').val();
    		 window.wioEventBus.publish('changeDeliveryLocation', zipcode);
    	 }
    	 else
    		 {
	    		 $('#deliveryFailMessage').removeClass('hide');
	    		 $('#zip-group').addClass('hide');
	    		 $('#deliveryFailMessage').removeClass("warning").addClass("critical-notification");
	    		 $('#geDeliveryFailMessageSpan').text(messages.ERR_GROCERY_INVALID_ZIP);
    		 }
    },
    
    availabilityFormOnSubmit: function(event) {
      event.preventDefault();
      if (COSTCO.ScheduledDeliverable.validate.deliveryAvailabilityForm(event.currentTarget.form || event.currentTarget)) {
        var zipcode = $('#delivery-zip').val();
        var zipcodeCookie = $.cookie('invCheckPostalCode');
        var vendorSku = '';
        if (costcoStoreFeatures.GE_RESPONSE_CACHEING_ENABLED) {
        	vendorSku = $('#deliveryVendorSku').val();
        } else {
        	vendorSku = $('#deliveryVendorSkuArr').val();
        }
        var productSku = $('#productPartnumberVal').val();
	    var url = "AjaxDeliveryReservationCalendarCmd?storeId=10301&deliveryVendorSku=" + vendorSku + "&zipCode=" + zipcode + "&productSku=" + productSku;
        $('#deliveryAvailabilityZip').val(zipcode);
        
        let response = '';
        
        if (costcoStoreFeatures.GE_RESPONSE_CACHEING_ENABLED) {
            response = ScheduledDeliverable.doesDeliveryAvailablityExists(vendorSku, zipcode);
        }
        
        let serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
        
        if(zipcode === zipcodeCookie){
        	if (response != '' ) {
            	ScheduledDeliverable.deliveryCalendarSuccess(response);
    	    } else {
    	    	COSTCO.ScheduledDeliverable.submitDeliverableAvailabilityAjax({
                    sku: vendorSku,
                    url: url,
                    productSku : productSku,
                    zipCode: zipcode
                  });
    	    }
        }else {
	        if (response != '' ) {
	        	ScheduledDeliverable.deliveryCalendarSuccess(response);
		    } else {
	             serviceToUpdateCookies(zipcode)
	             .then(() => {
	             	 var state = $.cookie('invCheckStateCode');
	             	 window.wioEventBus.publish('changeDeliveryLocation', zipcode);
	             })
	            .fail((data) => {
	              // bing failed
	              $('#zip-group').addClass('hide');
	              let errorContainer = $('#zip-group').find('label.error');
	              errorContainer.empty();
	              errorContainer.append(messages.ERR_ENTER_ZIPCODE);
	              errorContainer.show();
	            });
		    }
        }
      }
    },
    submitDeliverableAvailabilityAjax: function(settings) {
      COSTCO.ScheduledDeliverable.disableZipInput();
      COSTCO.util.ajaxSend();
      $.ajax({
        url: "/" + settings.url,
        type: 'POST',
        dataType: 'json',
        success: function(data, textStatus, xhr) {
        	if (costcoStoreFeatures.GE_RESPONSE_CACHEING_ENABLED) {
        		ScheduledDeliverable.cacheDeliveryAvailability(data);
        	}
        	ScheduledDeliverable.deliveryCalendarSuccess(data);
        },
        complete: function() {
          COSTCO.ScheduledDeliverable.enableZipInput();
          COSTCO.util.ajaxComplete();
        }
      });
    },
    resetDeliverableForm: function(url) {
      $('#prod-page-delivery').removeClass('hide').addClass('form-group');
      //$('#DeliveryAvailabilityForm')[0].reset();
      $('#deliveryDateMessage').addClass('hide');
      $('#deliveryFailMessage').addClass('hide');
      $('#deliveryLocationText').addClass('hide');
      $('#zip-group').removeClass('hide');
      $('#deliveryInfoText').addClass('hide');
      $('#geDeliveryFailMessageSpan').text('');
      $('[name=select-options]').prop("disabled", true);
      $("[name='select-options']").unbind('click');
      $('#delivery-zip').focus();
      $('#sign-in-to-buy-button-v2').removeClass('primary-button-v2').addClass('secondary-button-v2');
      $('#link-membership-for-price').removeClass('primary-button-v2').addClass('secondary-button-v2');
      
      for(var i = 0; i < products[0].length; i++) {
			if(products[0][i].inventory !== COSTCO.util.productConstants.inv_outOfStock) {
				products[0][i].zipcodeAvailabilityMessage = '0';
				products[0][i].zipcodeAvailabilityResponseCode = COSTCO.util.productConstants.check_StatusSuccess;
			}                           
      }
      
    },
    attachEventSelectOptions: function(settings) {
      //Enable select options button
      $("[name='select-options']").removeAttr('disabled');
      $("[name='select-options']").unbind('click').click(function() {
        //check does variants selected
        if ("unselected" != $('select[type="select-variants"] option:selected').val()) {
          // COSTCO.util.ajaxSend();
          //call GetParts Webservice
          $.ajax({
            url: '/AjaxGetPartsAndServicesDeliveryCmd?deliveryVendorSku=' + settings.sku + '&zipCode=' + settings.zipCode + '&categoryCode=' + settings.categoryCode,
            type: 'POST',
            //data: cleanData,
            dataType: 'json',
            success: function(data, textStatus, xhr) {
              if (data.errorCode) {
                if (data.errorCode == 2510) { // session timeout
                  document.location.href = 'Logoff?URL=ReLogonFormView';
                  return;
                }
              }
              //console.log('Success !!'+JSON.stringify(data.DeliveryJSONResponse));
              COSTCO.ScheduledDeliverable.showSelectOptionsModal(JSON.parse(data.DeliveryJSONResponse));
            },
            complete: function() {
              COSTCO.util.ajaxComplete();
            }
          });
        } else {
          $product_error = $('#ProductForm').find('.product-error');
          $product_error.html(messages.ERR_ADD_TO_CART_SELECT_ONE);
        }
      });
    },
    showSelectOptionsModal: function(data) {
      //set global variable to capture service selection form user in Select options modal.
      partsandservices = data;
      //Show modal
      phelper.show_options_modal(data);
      //attach onclick event event to add-to-cart button on select options modal
      $("[name='select-options-addtocart']").unbind('click').click(function() {
    	  COSTCO.ScheduledDeliverable.selectOptionsAddToCartBtnClick();
      });
    },
    selectOptionsAddToCartBtnClick: function() {

      $('#ProductForm #configuredInfo').val(JSON.stringify(partsandservices));
      $('#ProductForm #configuredInfoType').val("7");

      $('#costcoModal').on('hidden.bs.modal',function(e){
        $('#ProductForm').submit();
      });

      $('#costcoModal').modal('hide');

    },
    servicesSelection: function(element) {
    	COSTCO.ScheduledDeliverable.selectServicesById(element.name, $(element).is(':checked')? true : false);
    },
    selectServicesById: function(id, selected) {
      $.each(partsandservices.services, function(index, value) {
        if (value.id == id) {
          value.selected = selected;
          return;
        }
      });
    },
    hideServicesById: function(id, selected) {
      $.each(partsandservices.services, function(index, value) {
        if (value.id == id) {
          value.hidden = selected;
          return;
        }
      });
    },
    /**
     * Creates list of parts and services html to be added to a modal.
     * @param data = Parts and Services JSON
     * @return htmls array  - Array that contains HTML for parts and services list
     * and HTML for remarks
     *
     */
    create_parts_and_services_list: function(data) {
      //Services
      var servicesList = new Array();
      var partsList = new Array();
      var dishwasherPartsList = new Array();
      var servicesPartsRemarksList = new Array();
      var remark_html = '';
      var remarkMade = false;

      $.each(data.services, function(index, value) {
        if (value.serviceType.toUpperCase() == 'SERVICE') {
          servicesList.push(value);
        } else if (value.serviceType.toUpperCase() == 'PART' && value.groupId == 1) {
          dishwasherPartsList.push(value);
        } else if (value.serviceType.toUpperCase() == 'PART') {
          partsList.push(value);
        }
        if (value.remark != "undefined" && value.remark != "" && value.remark != null && value.availabilityType != 'hidden') {
        	servicesPartsRemarksList.push(value);
        	remarkMade = true; //indicate that we need to add the remarks container
	        remark_html += COSTCO.util.tmpl('tmpl_delivery_service_remark', { remark: value.remark });
        }
      });
      
      // Add services not included to remark list
      if(data.installationAvailable != undefined && data.installationAvailable != 'true'){
    	  if(data.installationAvailabilityText != undefined && data.installationAvailabilityText.trim().length > 0){
    		  remarkMade = true;
    		  remark_html += COSTCO.util.tmpl('tmpl_delivery_service_remark', {
    			  remark: messages.SCHED_DELIV_NO_INSTALLATION_ALERT
    	      });
    	  }
      }
      
      var partsservices_html = '';
      var dishwasherParts_html = '';

      $.each(servicesList, function(index, value) {
        var yesChecked = 'checked';
        var noChecked = '';
        if (!value.selected) {
          yesChecked = '';
          noChecked = 'checked';
        }
        partsservices_html += COSTCO.util.tmpl('tmpl_selected_delivery_service', {
          description: value.question,
          code: value.id,
          yes_checked: yesChecked,
          no_checked: noChecked
        });
      }); //end loop
      var remark_container_html = '';
      if (remarkMade) {
        remark_container_html += COSTCO.util.tmpl('tmpl_delivery_service_remark_container', {
          remarks: remark_html
        });
      }
  
      //Display the rest of the part list
      $.each(partsList, function(index, value) {
    	  if(value.availabilityType == undefined || value.availabilityType == 'visible' || value.availabilityType == 'null' || value.availabilityType == ""){
    		  if(value.description.toUpperCase().includes(":")) {
		   			  var new_description_array  = value.description.split(":");
        			  var new_description = new_description_array[0];
        			  var new_description_remark = new_description_array[1];
	        		  partsservices_html += COSTCO.util.tmpl('tmpl_selected_delivery_parts_description_remark', {
	        			  description: new_description,
	        			  remark: new_description_remark
	    	          });
		   	  } else if(!value.selected)  {
		   		partsservices_html += COSTCO.util.tmpl('tmpl_deselected_delivery_parts_description', {
					  description: value.description
					});
		   		  
		   	  } else {
		   		partsservices_html += COSTCO.util.tmpl('tmpl_selected_delivery_parts_description', {
					  description: value.description
					}); 
		   	  }
  		  }
      });

      if (dishwasherPartsList.length > 0) {
    	  // sort the Array so that parent records go on top (without dependency id's)
    	  // this will also put them into a better numerical order if more DW hose lengths are used
    	  dishwasherPartsList.sort(function(a, b) {
    		  var depIdA = a.dependent_service_ids.length;
    		  var depIdB = b.dependent_service_ids.length;
    		  if (depIdA < depIdB) {
    			  return -1;
    		  }
    		  if (depIdA > depIdB) {
    			  return 1;
    		  }
    		  // compare must be equal
	    	return 0;
    	  });
    	  


		  // build the parent parts out into radio buttons
		  $.each(dishwasherPartsList, function(index, value) {
		    if (value.dependent_service_ids.length <= 0) {
		      // process parent records
		
		  var dishwasherRadioButton = document.createElement("INPUT"); // make a cool input button object
		      dishwasherRadioButton.setAttribute("type", "radio");
		      dishwasherRadioButton.setAttribute("name", value.serviceType); // part
		      dishwasherRadioButton.setAttribute("class", "control__indicator"); // bootstrap for radio button
		      dishwasherRadioButton.setAttribute("id", value.id); // M911
		  if (value.selected) { // true
		      dishwasherRadioButton.setAttribute("checked", "checked"); // sets the default checked radio button
		      //note: the attribute that sets the default stays on that element even after the selection changes
		  }
		      dishwasherRadioButton.setAttribute("onchange", "COSTCO.ScheduledDeliverable.dishwasherPartsSelect(this)");
		      //note: onchange does not trigger when the radio button changes to a de-selected state (its much like a onclick)
		
		  var dishwasherRadioButtonToHTML = dishwasherRadioButton.outerHTML; // convert it for passing to template
		
		  if (value.selected == true && value.dependent_service_ids.length <= 0){
		      dishwasherParts_html = COSTCO.util.tmpl('tmpl_selectable_delivery_dishwasher_parts', {
		        costco_ge_dishwasher_part_radio_button: dishwasherRadioButtonToHTML,
		        description: value.description
		      }) + dishwasherParts_html;
		  } else {
		    dishwasherParts_html += COSTCO.util.tmpl('tmpl_selectable_delivery_dishwasher_parts', {
		          costco_ge_dishwasher_part_radio_button: dishwasherRadioButtonToHTML,
		          description: value.description
		        });
		      }
		    }
		  });
		  //put the radio buttons into a container
	      dishwasherParts_html = '<div class="costco_ge_dishwasher_parts_container">' +
	                                '<p class="body-copy-bold">' + messages.SCHED_DELIV_DISHWASHER_KIT + '</p>' +
	                                dishwasherParts_html +
	                              '</div>';
	      partsservices_html += dishwasherParts_html;
      }

      var htmls = {
        'partsservices_html': partsservices_html,
        'remark_html': remark_container_html
      }
      return htmls;
    },
    /**
     * Gathers required data from JSON's embedded in the HTML and
     * launches the EditParts and Services Modal
     * @param orderItemID = ID for the given item in the cart. Needed to references
     * embedded JSON in HTML.
     *
     */
    editPartsAndServices: function(orderItemId) {
      var selected_product = $("#modalData_" + orderItemId).text();
      selected_product = $.parseJSON(selected_product);
      var scheduledDeliveryConfig = $("#scheduledDeliveryConfig_" + orderItemId).text();
      scheduledDeliveryConfig = $.parseJSON(scheduledDeliveryConfig);
      //create global variable
      partsandservices = scheduledDeliveryConfig;
      var options_htmls = COSTCO.ScheduledDeliverable.create_parts_and_services_list(scheduledDeliveryConfig);
      partsservices_html = options_htmls['partsservices_html'];
      remark_container_html = options_htmls['remark_html'];
      var items_html = COSTCO.util.tmpl('tmpl_edit_delivery_Item_services', {
        img_url: selected_product.img_url,
        item_name: selected_product.item_name,
        item_url: selected_product.item_url,
        item_number: selected_product.item_number,
        partsservices: partsservices_html,
        remarksContainer: remark_container_html
      });
      $('.modal-footer').addClass('hide');
      COSTCO.dialog.createExtDialogBox({
        title: messages.SCHED_DELIV_EDIT_OPTIONS_HEADING,
        body: COSTCO.util.tmpl('tmpl_edit_options_modal', {
          items: items_html
        }),
        onclose: function() {
          $('.modal-footer').removeClass('hide');
        }
      });
      //attach onclick event event to save changes button on edit options modal
      $("[name='select-options-edit-config']").unbind('click').click(function() {
    	  COSTCO.ScheduledDeliverable.editSchedDeliveryConfigBtnClick(orderItemId, scheduledDeliveryConfig);
      });
    },
    /**
     * Updates the server and local copies of ScheduledDeliveryConfig with updates
     * @param orderItemId - identifies the cart entry the ScheduledDeliveryConfig is associated with
     * @param scheduledDeliveryConfig - JSON that contains all Scheduled Delivery information
     */
    editSchedDeliveryConfigBtnClick: function(orderItemId, scheduledDeliveryConfig) {
      window.COSTCO.ScheduledDeliverable.updateLocalCopySchedDeliveryConfig(orderItemId, scheduledDeliveryConfig);
      window.COSTCO.ScheduledDeliverable.updateServerCopySchedDeliveryConfig(orderItemId, scheduledDeliveryConfig);
    },
    /**
     * Updates the local copy of ScheduledDeliveryConfig with updates
     * @param orderItemId - identifies the cart entry the ScheduledDeliveryConfig is associated with
     * @param scheduledDeliveryConfig - JSON that contains all Scheduled Delivery information
     */
    updateLocalCopySchedDeliveryConfig: function(orderItemId, scheduledDeliveryConfig) {
      //update the JSON in the page
      var configJson = JSON.stringify(scheduledDeliveryConfig)
      var $configJsonContainer = $("#scheduledDeliveryConfig_" + orderItemId);
      $configJsonContainer.text(configJson);
      //loop through and update response in the services text
      $.each(scheduledDeliveryConfig.services, function(index, value) {
        if (value.serviceType == 'Service') {
          var serviceId = value.id;
          var $responseContainer = $("#scheduledDeliveryServiceResponse_" + orderItemId + "_" + serviceId);
          if (value.selected) {
            $responseContainer.text(messages.SCHED_DELIVY_SERVICE_YES);
          } else {
            $responseContainer.text(messages.SCHED_DELIVY_SERVICE_NO);
          }
        }
      });
    },
    /**
     * Updates the server copy of ScheduledDeliveryConfig with updates. Will close any modal id=costcoModal
     * @param orderItemId - identifies the cart entry the ScheduledDeliveryConfig is associated with
     * @param scheduledDeliveryConfig - JSON that contains all Scheduled Delivery information
     */
    updateServerCopySchedDeliveryConfig: function(orderItemId, scheduledDeliveryConfig) {
      var url = '/AjaxUpdateScheduledDeliveryCmd?storeId=10301&orderItemId=' + orderItemId;
      console.log(scheduledDeliveryConfig);
      var configJson = JSON.stringify(scheduledDeliveryConfig)
      console.log(configJson);
      var req = encodeURIComponent(configJson);
      //submitAjax(url, req, "Upated Parts and Services", $('#updateMessage'), $('#results'));
      $.ajax({
        url: url,
        type: 'POST',
        data: 'payload=' + req,
        dataType: 'json',
        success: function(data, textStatus, xhr) {
          if (data.errorCode) {
            if (data.errorCode == 2510) { // session timeout
              document.location.href = 'Logoff?URL=ReLogonFormView&storeId=' + wcs.storeId;
              return;
            }
          } else {
            if (data.code == 500) {
              console.log(data.message);
            } else {
              console.log(data.message);
              //close modal
              $('#costcoModal').modal('hide');
            }
          }
        }
      });
    },
    handlePartsAndServicesEdit: function(element, orderItemId) {
      if(COSTCO.ScheduledDeliverable.update_deliveryDate_orderItemId != orderItemId)	{
	      var scheduledDeliveryConfigJSON = window['scheduledDeliveryConfig_' + orderItemId];
	      var hasErrors = false;
	      var serviceType = $(element).attr('service-type');
	      if (serviceType == 'service') {
	        $.each(scheduledDeliveryConfigJSON.services, function(i, service) {
	          if ($(element).attr('name') == service.id) {
	            service.selected = $(element).is(':checked');
	            return false; // break for each loop
	          }
	        });
	      } else if (serviceType == 'Part') {
	    	  var partSelected = $(element).attr("id");
	          $.each(scheduledDeliveryConfigJSON.services, function(i, service) {
	        	//reset all parts to unselected
	            if (service.groupId == '1') {
	            	service.selected = false;
	            } 
	            // set part selected and it's children to selected: true
	            if (service.id == partSelected) {
	            	service.selected = true;
	            }
	         });
	      } else {
	        var name = $(element).attr('name');
	        if ('deliveryDate_' + orderItemId == name) {
	          var date = $('#deliveryDate_' + orderItemId).datepicker().val();
	          if (date) {
	        	  
	    	    var formattedDate = new Date(date);
	          
	            // OMS needs normally formatted Date
	    	    var month = '' + (formattedDate.getMonth() + 1);
	            var day = '' + formattedDate.getDate();
	          
	            if (month.length < 2) 
	                month = '0' + month;
	            if (day.length < 2) 
	                day = '0' + day;
	          
	            var year = formattedDate.getFullYear();
	            var scheduledDeliveryJSONDate = year + '-' + month + '-' + day;
	            if(scheduledDeliveryJSONDate != scheduledDeliveryConfigJSON['deliveryDate']){
		            var noOfItems = $('.order-item').length;
		            for (var i = 1; i <= noOfItems; i++) {
		                var scheduledOrderItemId = $('#orderItem_'+i).val()
		                var itemScheduledDeliveryConfigJSON = window['scheduledDeliveryConfig_' + scheduledOrderItemId];
		                if(typeof(itemScheduledDeliveryConfigJSON) !== 'undefined' && orderItemId != scheduledOrderItemId 
		                		&& $('#deliveryDate_' + scheduledOrderItemId).val() != date && !date.includes("/")){
		                	itemScheduledDeliveryConfigJSON['deliveryDate'] = year + '-' + month + '-' + day;
		                	itemScheduledDeliveryConfigJSON['costcoErrorCode'] = null;
		                	COSTCO.ScheduledDeliverable.update_deliveryDate_orderItemId = scheduledOrderItemId;
		                	COSTCO.ScheduledDeliverable.date_picker_update($('#deliveryDate_' + scheduledOrderItemId), scheduledOrderItemId );
		                }
		            }
		            
		            scheduledDeliveryConfigJSON['deliveryDate'] = scheduledDeliveryJSONDate;
		            scheduledDeliveryConfigJSON['costcoErrorCode'] = null;
		            if (COSTCO.ScheduledDeliverable.validate.partsAndServicesDeliverableDates(element)) {
		              $('#parts-and-service-error-message_' + orderItemId).addClass('hide');
		              $('label[for="date_' + orderItemId + '"]').addClass('active');
		            } else {
		              hasErrors = true;
		            }
	            }else {
	            	hasErrors = true;
		        }
	          } else {
	            	hasErrors = true;
		      }
	          
	        } else if ('contactPhone_' + orderItemId == name) {
	          if (COSTCO.ScheduledDeliverable.validate.partsAndServicesPhone(element)) {
	            if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
	              scheduledDeliveryConfigJSON['contactPhone'] = $(element).val();
	            }
	          } else {
	            hasErrors = true;
	          }
	        }
	      }
	      if (!hasErrors) {
	    	  COSTCO.ScheduledDeliverable.update_deliveryDate_orderItemId = '';
	    	  COSTCO.ScheduledDeliverable.updateServerCopySchedDeliveryConfig(orderItemId, scheduledDeliveryConfigJSON);
	        
	      }
      }
    },
    togglePartsAndServices: function(elementId1, elementId2) {
      $('#' + elementId1).toggleClass('hide');
      $('#' + elementId2).toggleClass('hide');
    },
    /**
     * Function to convert dates from yyyy-mm-dd to mm/dd/yyyy
     * Conversion makes datepicker ADA compliance
     * @return array
     */
    convertScheduledDeliverableDates:  function(dates) {
        for (let i = 0; i < dates.length; i++) {
          let year = dates[i].split('-')[0];
          let month = dates[i].split('-')[1];
          let day = dates[i].split('-')[2];
          dates[i] = month + '/' + day + '/' + year;
        }
        return dates;
      },
    /**
     * Holds the available schedule deliverable dates for order items.
     * @type {Object}
     */
    schedule_deliveravle_dates: {},
    
    update_deliveryDate_orderItemId:'',
    
    date_picker_deliverable: function(element, orderItemId) {
      var options = [];
      options.input = element;
      var scheduledDeliveryConfigJSON = window['scheduledDeliveryConfig_' + orderItemId];
      var available_dates = [];
      if (scheduledDeliveryConfigJSON && scheduledDeliveryConfigJSON.deliveryAvailability) {
        var calendar_dates = scheduledDeliveryConfigJSON.deliveryAvailability.calendar_dates;
        if (calendar_dates) {
          for (i = 0; i < calendar_dates.length; i++) {
            if (calendar_dates[i].available) {
              available_dates.push(calendar_dates[i].date);
            }
          }
        }
      }
      COSTCO.ScheduledDeliverable.schedule_deliveravle_dates[orderItemId] = available_dates.map(function(date_str) { 
    	  return {
          date_obj: new Date(new Date(date_str).getTime() + new Date(date_str).getTimezoneOffset() * 60000),
          date_str: date_str
        }
      });
      $(options.input).datepicker({
        format: 'D, M dd, yyyy',
        autoclose: true,
        showOnFocus: false,
        orientation: "auto right",
        todayHighlight: true,
        datesEnabled: COSTCO.ScheduledDeliverable.convertScheduledDeliverableDates(available_dates),
        language: wcs.langId === '-25' ? 'fr' : 'en'
      }).on('changeDate', function(e) {
    	  if(typeof(e.date) !== 'undefined'){
	        // The change event needs the date string to pass to the server.
	        console.log("changeDate : " + e.date);
	        var date_str = "",
	          selected_date = e.date;
	        this.allowed_objs.forEach(function(allowed_obj) {
	          var date_obj = allowed_obj.date_obj;
	          if (selected_date.getDate() == date_obj.getDate() && selected_date.getMonth() == date_obj.getMonth() && selected_date.getFullYear() == date_obj.getFullYear()) {
	            date_str = allowed_obj.date_str;
	            return;
	          }
	        })
    	  }
      }.bind({
        allowed_objs: COSTCO.ScheduledDeliverable.schedule_deliveravle_dates[orderItemId]
      }));
      $(options.input).datepicker('show');
      $(options.input).addClass('datepicker-initialized');
    },
    date_picker_update: function(element, orderItemId) {
        var options = [];
        options.input = element;
        var scheduledDeliveryConfigJSON = window['scheduledDeliveryConfig_' + orderItemId];
        	
        var available_dates = [];
        if (scheduledDeliveryConfigJSON && scheduledDeliveryConfigJSON.deliveryAvailability) {
          var calendar_dates = scheduledDeliveryConfigJSON.deliveryAvailability.calendar_dates;
          if (calendar_dates) {
            for (i = 0; i < calendar_dates.length; i++) {
              if (calendar_dates[i].available) {
                available_dates.push(calendar_dates[i].date);
              }
            }
          }
        }
        $(options.input).datepicker({
          format: 'D, M dd, yyyy',
          autoclose: true,
          showOnFocus: false,
          orientation: "auto right",
          todayHighlight: true,
          datesEnabled: COSTCO.ScheduledDeliverable.convertScheduledDeliverableDates(available_dates),
          language: wcs.langId === '-25' ? 'fr' : 'en',
        }).on('changeDate', function(e) {
      	  if(typeof(e.date) !== 'undefined' && COSTCO.ScheduledDeliverable.update_deliveryDate_orderItemId === e.target.id.replace('deliveryDate_','')){
  	        // The change event needs the date string to pass to the server.
  	        console.log("changeDate on update: " + e.date);
	  	    if($("#deliveryDateDisplayMode_"+orderItemId).length > 0){
	  	    	let dateVal = e.date.getDate();
	            let month = e.date.getMonth();
	            let year = e.date.getFullYear();
	            let day = e.date.getDay();
	  	    	let date_str_formatted = COSTCO.OrderItems.formatDate(day,dateVal,month,year);
	  	    	$("#deliveryDateDisplayMode_"+orderItemId).html(messages.SCHEDULED_DELIVERY_DELIVERY_DATE + ": " + date_str_formatted);
	        }
  	        var date_str = "",
  	          selected_date = e.date;
      	  }
        });
        $(options.input).datepicker('setDate', new Date(new Date(scheduledDeliveryConfigJSON.deliveryDate).getTime() + (new Date(scheduledDeliveryConfigJSON.deliveryDate).getTimezoneOffset() * 60 * 1000)) );
        $("label[for='date_"+orderItemId+"'].form-label").addClass('active');
      },
    handleZipCodeChange: function(zipcode) {
      var options = {
        url: "/AjaxScheduledDeliveryUpdateCmd",
        method: "POST",
        dataType: 'json',
        data: {
          'authToken': COSTCO.Checkout.getAuthToken(),
          'zipCode': zipcode
        },
        replaceKey: {
          original: 'order-items',
          replace: 'order-items'
        }, 
        done: function(){
        }
      };
      COSTCO.Checkout.ajax_update_state(options);
    },
    dishwasherPartsSelect: function(element) {
      var partSelected = $(element).attr("id");

      //iterate through all dishwasher parts and set to not selected
      if (partsandservices.services.length > 0) {
        $.each(partsandservices.services, function(index, value) {
          if (value.serviceType.toUpperCase() == "PART" && value.groupId == 1) {
            //reset all parts to unselected
        	  COSTCO.ScheduledDeliverable.selectServicesById(value.id, false);

            // set part selected and it's children to selected: true
            if (value.id == partSelected) {
            	COSTCO.ScheduledDeliverable.selectServicesById(value.id, true);
            }

            if (value.dependent_service_ids.length > 0) {
              var thisId = value.id;
              $.each(value.dependent_service_ids, function(index, value) {
                if (value == partSelected) {
                	COSTCO.ScheduledDeliverable.selectServicesById(thisId, true);
                }
              });
            }
          }
        });
      }
    }, // end of dishwasherPartsSelect
    
    /**
     * If the call to AjaxDeliveryReservationCalendarCmd is executed this method is used for cacheing.
     * It receives the data from response and store it in  DeliveryReservationCalendarData object which is
     * stored as JSON in session storage. 
     * 
     * @param data
     * */
    cacheDeliveryAvailability: function(data) {
    	let deliveryReservationCalendarData = JSON.parse(sessionStorage.getItem('DeliveryReservationCalendarData'));
		if (deliveryReservationCalendarData == null) {
			deliveryReservationCalendarData = [];
		}
		var deliveryReservationCalendar = new Object();
		deliveryReservationCalendar.deliveryVendorSku = data.deliveryVendorSku[0];            
		deliveryReservationCalendar.zipCode = data.zipCode;
		deliveryReservationCalendar.data = data;
		deliveryReservationCalendarData.push(deliveryReservationCalendar);
  		
		sessionStorage.setItem('DeliveryReservationCalendarData', JSON.stringify(deliveryReservationCalendarData));  
    },
    
    /**
     * Compare input value of sku and zipcode with saved values in session storage. 
     * If data exists returns the data if not returns empty string. 
     * @param vendorSku number and zipCode entered.
     * @return response data from cached session storage object DeliveryReservationCalendarData. 
     * */
    doesDeliveryAvailablityExists: function(vendorSku, zipCode) {
  	  let response = '';
      let deliveryReservationCalendarData = []; 
  	  deliveryReservationCalendarData = JSON.parse(sessionStorage.getItem('DeliveryReservationCalendarData'));
  	  
  	  $(deliveryReservationCalendarData).each(function(i, obj) {
    	  if (obj.deliveryVendorSku == vendorSku && obj.zipCode == zipCode) {
    		  response = obj.data;
    		  return false;
    	  }
      });
  	  	
  	  return response;	
    },
    
    /**
     * Data manipulation when ajax call is executed or when data is passed from session storage. 
     * @param data - represents JSON response with messages, status and product number, sku number and zipcode.
     * */
    deliveryCalendarSuccess: function(data) {

        $('#deliveryDateMessageTxt').text('');
        if (data.errorCode) {
          if (data.errorCode === 2510) { // session timeout
            document.location.href = 'Logoff?URL=ReLogonFormView&storeId=' + wcs.storeId;
            return;
          }
        } else {
      	if (data['ResponseCode'] === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {  
      		$('#deliveryFailMessage').removeClass('hide');
      		$('#zip-group').addClass('hide');
              $('#geDeliveryFailMessageSpan').text(data['message']);
              $('#prod-page-delivery').addClass('hide');
      	} else {
         
      		COSTCO.ScheduledDeliverable.resetDeliverableForm();
      		
	            for(var i = 0; i < products[0].length; i++) {
					if(products[0][i].inventory !== COSTCO.util.productConstants.inv_outOfStock) {
						var itemMsgKey = 'message_' + products[0][i].manufacturerPartNumber.trim();
						var itemResponseCodeKey = 'ResponseCode_' + products[0][i].manufacturerPartNumber.trim();
						var itemMsgCodeKey = 'messageCode_' + products[0][i].manufacturerPartNumber.trim();
						
						products[0][i].zipcodeAvailabilityMessage = data[itemMsgKey];
						products[0][i].zipcodeAvailabilityMessageCode = data[itemMsgCodeKey];
						products[0][i].zipcodeAvailabilityResponseCode = data[itemResponseCodeKey];
						
					}                           
	            }
	            COSTCO.CMath.updateGEStockAvailability();
	            COSTCO.CMath.bindVariantProducts();
	            
	            //attach event to select options button
	            COSTCO.ScheduledDeliverable.attachEventSelectOptions({
	                sku: $('#deliveryVendorSku').val(),
	                zipCode: data.zipCode,
	                categoryCode:$('#categoryCode').val()
	            });
	              
	            var vendorSku = $('#deliveryVendorSku').val();
	            var msgKey = 'message_' + vendorSku;
	            var msgCodeKey = 'messageCode_' + vendorSku;
	            var delJSONResponseKey = 'DeliveryJSONResponse_'+vendorSku ;
	            var responseCodeKey = 'ResponseCode_'+vendorSku ;
	            
	            if (data[responseCodeKey] === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
	              if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            	$('#deliveryFailMessage').removeClass('hide');
	            	$('#zip-group').addClass('hide');
	            	$('#geDeliveryFailMessageSpan').text(data[msgKey]);
	            	if(data[msgCodeKey] === COSTCO.util.productConstants.inv_backorderd){
						$('#deliveryFailMessage').addClass("warning").removeClass("critical-notification");
						$('[name=select-options]').prop("disabled", false);
					} else {
						$('#deliveryFailMessage').removeClass("warning").addClass("critical-notification");
						$('[name=select-options]').prop("disabled", true);
					}
	              }
	              else {
	            	$('#deliveryFailMessage').removeClass('hide');
	            	$('#zip-group').addClass('hide');
		            $('#geDeliveryFailMessageSpan').text(data[msgKey]);
		            $('#prod-page-delivery').addClass('hide');  
		            if(data[msgCodeKey] === COSTCO.util.productConstants.inv_backorderd){
						$('[name=select-options]').prop("disabled", false);
					} else {
						$('[name=select-options]').prop("disabled", true);
					}
	              }
	            } else {
	              
	              console.log(data[delJSONResponseKey]);
	              $('#deliveryFailMessage').addClass('hide');
	              $('#prod-page-delivery').addClass('hide');
	              $('#zip-group').addClass('hide');
	              $('#deliveryDateMessage').removeClass('hide').addClass('success');

	              if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            	let deliveryDate = data[msgKey];
	            	let date = deliveryDate ? new Date(deliveryDate).toLocaleDateString('en-US', {weekday: 'long', month : 'long', day:'numeric'}) : "";
	            	$('#deliveryDateMessageTxt').text(date);
	              } else {
	            	$('#deliveryDateMessageTxt').text(data[msgKey]);
	              }

	              $('#deliveryLocationText').removeClass('hide');
	              $('#deliveryInfoText').removeClass('hide');
	              $('#deliveryZipCode').text(data.zipCode);
	              $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	              $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	            }
	             
	            if($('label', '#variants .variantContainer').length > 0){
	            var swatch = $('.swatchDropdown').find('option[data-swatch]:not([disabled])').first().data('swatch');
		            if(typeof swatch === 'undefined' || swatch === null) {
	            	$('[name=select-options]').prop("disabled", true);
		            }
	            }
      		}
        }
        }
  }
  // end of ScheduledDeliverable
  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = new Object();
  }
  window.COSTCO.ScheduledDeliverable = ScheduledDeliverable;
  return ScheduledDeliverable;
});



// WEBPACK FOOTER //
// ./js/product/scheduledDeliverable.js